import * as React from "react";
import { cn } from "../lib/utils.js";

/**
 * DescriptionList (W-2 Profile): read-only label/value pairs. Values arrive
 * formatted; `mono` shows references (masked IDs) as returned, in
 * monospace; `muted` styles a placeholder value such as "Not provided".
 */

export interface DescriptionItem {
  id: string;
  term: string;
  description: React.ReactNode;
  mono?: boolean;
  muted?: boolean;
}

export interface DescriptionListProps extends React.ComponentProps<"dl"> {
  items: DescriptionItem[];
}

function DescriptionList({ items, className, ...props }: DescriptionListProps) {
  return (
    <dl
      data-slot="description-list"
      className={cn("flex flex-col divide-y rounded-lg border bg-card text-card-foreground", className)}
      {...props}
    >
      {items.map((item) => (
        <div key={item.id} data-field={item.id} className="flex flex-col gap-0.5 px-4 py-3 sm:flex-row sm:gap-4">
          <dt className="text-sm text-muted-foreground sm:w-40 sm:shrink-0">{item.term}</dt>
          <dd
            className={cn(
              "min-w-0 break-words",
              item.mono && "font-mono",
              item.muted && "text-muted-foreground",
            )}
          >
            {item.description}
          </dd>
        </div>
      ))}
    </dl>
  );
}

export { DescriptionList };
